import $ from 'jquery';
import * as headerCart from 'header.cart';
import * as headerLogo from 'header.logo';
import * as headerDropDowns from 'header.dropdownmodule';
import * as headerMainFlyout from 'header.mainflyout';
import * as headerSimpleFlyout from 'header.simpleflyout';
import * as headerHomeDecorFurnitureFlyout from 'header.homedecorfurnitureflyout';
import * as headerSpecialsFlyout from 'header.specialsflyout';
import * as headerDIYFlyout from 'header.diyflyout';
import * as headerHsFlyout from 'header.hsflyout';
import * as headerMyaccount from 'header.myaccount';
import * as headerSearch from 'header.search';
import * as headerStorefinderCore from 'header.storefinder.core';
import * as headerStoreFinder from 'header.storefinder';
import * as headerTooltips from 'header.tooltips';
import * as headerShoppingLinks from 'header.shoppinglinks';
import * as headerTaskLinks from 'header.tasklinks';
import * as footerEmail from 'footer.email';
import * as footerTagline from 'footer.tagline';
import * as footerPclink from 'footer.pcLink';
import footerOrderTracking from 'footer.orderTracking';
import * as localizationPopup from 'localizationPopup';
import * as gestureHandler from 'global.gestureHandler';
import * as headerAnalytics from 'header.analytics';

(function () {
  const readyEvent = document.createEvent('CustomEvent');
  readyEvent.initCustomEvent('hfapp-ready', true, false, {});
  headerAnalytics.init();
  headerCart.init();
  headerMainFlyout.init();
  headerSimpleFlyout.init();
  headerHomeDecorFurnitureFlyout.init();
  headerSpecialsFlyout.init();
  headerDIYFlyout.init();
  headerHsFlyout.init();
  headerDropDowns.init();
  headerLogo.init();
  headerMyaccount.init();
  headerSearch.init();
  headerTooltips.init();
  headerStorefinderCore.init();
  headerStoreFinder.init();
  headerShoppingLinks.init();
  headerTaskLinks.init();
  footerEmail.init();
  footerTagline.init();
  footerPclink.init();
  footerOrderTracking.init();
  localizationPopup.init();
  gestureHandler.init();

// Triggers HFApp is loaded and ready
  $('body').trigger('hfapp-ready');
  document.dispatchEvent(readyEvent);
})();
